/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesTr = {
  privacy: {
    pageTitle: "Gizlilik Politikası",
    lastUpdated: "Son güncelleme: 1 Haziran 2026",
    introduction: {
      title: "Giriş",
      body: "WasOK, kullanıcıların daha önce satın aldığı, puanladığı veya incelediği ürünleri hatırlamalarına yardımcı olmak için tasarlanmış, yerel öncelikli bir alışveriş yardımcısı uygulamasıdır.\n\nBu Gizlilik Politikası, uygulamayı kullanırken hangi bilgilerin işlendiğini, verilerin nasıl saklandığını ve belirli üçüncü taraf hizmetlerinin nasıl çalışabileceğini açıklar.",
    },
    dataStored: {
      title: "Uygulama Tarafından Saklanan Veriler",
      body: "WasOK aşağıdaki bilgileri cihazınızda yerel olarak saklar:\n\n• taranan ürün barkodları\n• kullanıcı tarafından girilen ürün adları ve ayrıntıları\n• puanlar ve yorumlar\n• alışveriş listeleri\n• ürün kategorileri\n• fiyatlar ve mağaza bilgileri\n• ürün ve mağaza fotoğrafları\n\nÜrün verileriniz ve fotoğraflarınız WasOK sunucularına yüklenmez.",
    },
    permissions: {
      title: "Kullanılan İzinler",
      camera: {
        title: "Kamera",
        body: "Kamera erişimi şu amaçlarla kullanılır:\n\n• barkod tarama\n• ürün fotoğrafı çekme",
      },
      photos: {
        title: "Fotoğraflar ve Medya",
        body: "Fotoğraf veya galeri erişimi yalnızca şu durumlarda kullanılır:\n\n• ürünlere görüntü ekleme\n• fotoğraf içeren yedekleri geri yükleme",
      },
      files: {
        title: "Dosya ve Depolama Erişimi",
        body: "Dosya erişimi şu amaçlarla kullanılabilir:\n\n• yedek dosyalarını dışa aktarma\n• kullanıcı tarafından seçilen yedekleri içe aktarma\n• alışveriş listelerini veya yedekleri paylaşma",
      },
    },
    backup: {
      title: "Yedekleme ve Dışa Aktarma Özellikleri",
      body: "WasOK, uygulama verilerini ve isteğe bağlı fotoğrafları içeren yedek dosyaları oluşturmanıza olanak tanır.\n\nYedek dosyaları cihazınızda yerel olarak oluşturulur ve kullanıcının seçtiği hizmetlerle saklanabilir veya paylaşılabilir, örneğin:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• yerel cihaz depolaması\n\nWasOK yedekleri kendi sunucularına yüklemez.",
      onlineProductLookup: {
        title: "Çevrimiçi ürün araması",
        body: "Tercihlerde çevrimiçi barkod aramasını etkinleştirdiğinizde, WasOK ürün adı ve markası önermek için yalnızca taranan barkod numarasını herkese açık ürün veritabanlarına (örneğin Open Food Facts) gönderebilir. WasOK bu özellik için puanlarınızı, yorumlarınızı, fotoğraflarınızı, alışveriş listelerinizi, kategorilerinizi, mağaza bilgilerinizi veya yedek verilerinizi yüklemez. Bunu Tercihler'den istediğiniz zaman kapatabilirsiniz.",
      },
    },
    advertising: {
      title: "Reklam ve Üçüncü Taraf Hizmetleri",
      intro:
        "WasOK, belirli özellikler sağlamak için seçilmiş üçüncü taraf hizmetlerini kullanır.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob, uygulama içinde reklam göstermek için kullanılır.\n\nGoogle ve ortakları şu gibi bilgileri işleyebilir:\n\n• reklam tanımlayıcıları\n• cihaz bilgileri\n• IP adresi\n• tanılama ve kullanım bilgileri\n\nBelirli bölgelerdeki kullanıcılardan kişiselleştirilmiş reklamlar gösterilmeden önce onay istenebilir.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK, çökme olaylarını belirlemek ve uygulama kararlılığını iyileştirmek için Firebase Crashlytics kullanır.\n\nÇökme raporları şu gibi teknik bilgiler içerebilir:\n\n• cihaz modeli\n• işletim sistemi sürümü\n• uygulama sürümü\n• çökme tanılama bilgileri\n\nÇökme raporları kasıtlı olarak ürün puanlarınızı, notlarınızı, alışveriş listelerinizi veya fotoğraflarınızı içermez.",
      },
      externalProductDatabases: {
        title: "Harici Ürün Veritabanları",
        body: "Barkod arama işlevi, ürün bilgilerini almak için harici ürün veritabanlarını kullanabilir.\n\nDaha fazla bilgi için ilgili sağlayıcıların gizlilik politikalarını inceleyin.",
      },
    },
    dataSecurity: {
      title: "Veri Güvenliği",
      body: "WasOK, uygulama verilerini işletim sistemi tarafından sağlanan depolama mekanizmalarını kullanarak cihazınızda yerel olarak saklar.\n\nYerel uygulama verilerini korumak için makul önlemler alınsa da, hiçbir elektronik depolama yöntemi tamamen güvenli değildir.\n\nKullanıcılar, istenirse önemli verilerin yedeklerini tutmaktan sorumludur.",
    },
    children: {
      title: "Çocukların Gizliliği",
      body: "WasOK, 13 yaşın altındaki çocuklara yönelik değildir.",
    },
    notifications: {
      title: "Bildirimler",
      body: "WasOK, satın alma sonrası ürünleri puanlamanızı hatırlatmak için cihazınızda isteğe bağlı yerel bildirimler oluşturabilir.\n\nBu bildirimler cihazınızda yerel olarak oluşturulur ve zamanlanır; hesap veya uzak sunucu gerektirmez.\n\nBildirimleri cihaz ayarlarından veya destekleniyorsa uygulama içinden istediğiniz zaman kapatabilirsiniz.",
    },
    yourControl: {
      title: "Verileriniz Üzerindeki Kontrolünüz",
      body: "Şunları yapabilirsiniz:\n\n• saklanan ürünleri istediğiniz zaman düzenleyebilir veya silebilirsiniz\n• cihazınızdaki uygulama verilerini temizleyebilirsiniz\n• uygulamayı kaldırabilirsiniz\n• verilerinizin yedeklerini dışa aktarabilirsiniz",
    },
    changes: {
      title: "Bu Politikadaki Değişiklikler",
      body: "Bu Gizlilik Politikası zaman zaman güncellenebilir.\n\nDeğişiklikler, güncellenmiş sürüm yayınlandığında yürürlüğe girer.",
    },
    contact: {
      title: "İletişim",
      body: "Bu Gizlilik Politikası hakkında sorularınız varsa lütfen iletişime geçin:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Hizmet Şartları",
    lastUpdated: "Son güncelleme: 1 Haziran 2026",
    acceptance: {
      title: "Şartların Kabulü",
      body: "WasOK'u indirerek, yükleyerek veya kullanarak bu Hizmet Şartlarını kabul etmiş olursunuz.\n\nBu Şartları kabul etmiyorsanız uygulamayı kullanmamalısınız.",
    },
    license: {
      title: "Lisans",
      body: "WasOK, size bu Şartlara uygun olarak uygulamayı kullanmak üzere sınırlı, münhasır olmayan, devredilemez ve geri alınabilir bir lisans verir.",
    },
    acceptableUse: {
      title: "Kabul Edilebilir Kullanım",
      body: "Aşağıdakileri yapmamayı kabul edersiniz:\n\n• uygulamayı kötüye kullanmak\n• uygulamanın çalışmasına müdahale etmek\n• uygulamayı tersine mühendislik yapmaya veya değiştirmeye çalışmak\n• uygulamayı yürürlükteki yasa veya düzenlemelere aykırı kullanmak",
    },
    localData: {
      title: "Yerel Veriler ve Yedekler",
      body: "WasOK kullanıcı verilerini cihazda yerel olarak saklar.\n\nKullanıcılar, istenirse önemli verilerin yedeklerini tutmaktan sorumludur.\n\nYedekleme ve geri yükleme işlevi sağlanabilse de, WasOK saklanan verilerin kaybı, bozulması veya arızasına karşı garanti vermez.",
    },
    advertisements: {
      title: "Reklamlar",
      body: "Uygulama, Google AdMob dahil olmak üzere üçüncü taraf reklam ortakları tarafından sağlanan reklamlar gösterebilir.",
    },
    noWarranty: {
      title: "Garanti Yok",
      body: "WasOK, açık veya zımni hiçbir garanti olmaksızın \"olduğu gibi\" ve \"mevcut olduğu şekilde\" sunulur.\n\nŞunları garanti etmiyoruz:\n\n• uygulamanın her zaman kullanılabilir olacağını\n• uygulamanın hatasız olacağını\n• veri kaybının asla olmayacağını\n• tüm özelliklerin tüm cihazlarda kesintisiz çalışacağını",
    },
    limitationLiability: {
      title: "Sorumluluğun Sınırlandırılması",
      body: "Yasaların izin verdiği azami ölçüde, WasOK ve geliştiricileri aşağıdakilerden sorumlu tutulamaz:\n\n• veri kaybı\n• kâr kaybı\n• cihaz sorunları\n• dolaylı veya sonuç olarak ortaya çıkan zararlar\n• uygulamanın kullanımından veya kullanılamamasından kaynaklanan kesintiler",
    },
    thirdParty: {
      title: "Üçüncü Taraf Hizmetleri",
      body: "Belirli özellikler veya içerikler, reklam sağlayıcıları ve kullanıcı tarafından seçilen harici depolama/paylaşım hizmetleri dahil olmak üzere üçüncü taraf hizmetlerine dayanabilir.\n\nWasOK, üçüncü taraf hizmetlerinden veya politikalarından sorumlu değildir.",
    },
    productInformation: {
      title: "Ürün Bilgileri",
      body: "Belirli ürün ayrıntıları üçüncü taraf barkod arama hizmetlerinden elde edilebilir.\n\nWasOK, harici veri kaynakları tarafından sağlanan bilgilerin doğruluğunu, eksiksizliğini, kullanılabilirliğini veya uygunluğunu garanti etmez.\n\nKullanıcılar gerektiğinde ürün bilgilerini bağımsız olarak doğrulamalıdır.",
    },
    changesApp: {
      title: "Uygulamada Değişiklikler",
      body: "WasOK, önceden bildirimde bulunulmaksızın herhangi bir zamanda değiştirilebilir, güncellenebilir, askıya alınabilir veya durdurulabilir.",
    },
    changesTerms: {
      title: "Bu Şartlardaki Değişiklikler",
      body: "Bu Şartlar periyodik olarak güncellenebilir.\n\nGüncellemeler yürürlüğe girdikten sonra uygulamayı kullanmaya devam etmek, revize edilmiş Şartların kabulü anlamına gelir.",
    },
    contact: {
      title: "İletişim",
      body: "Bu Şartlarla ilgili sorular için iletişime geçin:\n\nsupport@wasok.app",
    },
  },
};
